'use client';

import { AnchorHTMLAttributes, PropsWithChildren } from 'react';
import { MouseEvent } from 'react';

import Link, { LinkProps } from 'next/link';

type AnchorProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps>;

type ScrollLinkProps = AnchorProps & LinkProps & PropsWithChildren & { smooth?: boolean };

const handleScroll = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const targetId = e.currentTarget.href.replace(/.*#/, '');
    const elem = document.querySelector(`#${targetId}`);
    elem?.scrollIntoView({ behavior: 'smooth', block: 'center' });
};

export const ScrollLink = ({ children, smooth, ...props }: ScrollLinkProps) => {
    return (
        <Link {...props} onClick={smooth ? handleScroll : void 0}>
            {children}
        </Link>
    );
};
